
import {defineComponent, PropType} from 'vue'

export default defineComponent({
  name: 'MessageBlock',
  props: {
    type: String as PropType<'warning' | 'error'>,
    message: String,
  }
})
